<template>
  <div data-component-group="threads-tables" data-component="grouped-threads">
    <table-base
      :columns="columns"
      :items="threads"
      :pages="pages"
      :can-edit-columns="false"
      :pagination="pagination"
      :is-loading="isLoading"
      :no-data-title="$t('no_submitted_deals')"
      :no-data-subtitle="$t('start_to_use_our_products')"
      has-custom-items-template
      :on-select-item="onSelectItem"
      :on-update-pagination="onUpdatePagination"
      :on-change-page="onChangePage"
      :sync-to-url="syncToUrl"
      class="table-base"
      @init-pagination="$emit('init-pagination', $event)"
    >
      <template v-slot:item-cell="scope">
        <StartDatePanel
          v-if="scope.cell.column.value === 'start_date'"
          :start-date="scope.cell.item.start_date"
        />
        <ThreadPanel
          v-else-if="scope.cell.column.value === 'deal'"
          :thread="scope.cell.item"
          :on-toggle-comments="onToggleComments"
          :show-tags="!isBusinessContact"
        />
        <CategoryPanel
          v-else-if="
            scope.cell.column.value === 'category' &&
              scope.cell.item.type.name === 'Deal'
          "
          :category="scope.cell.item.category"
        />
        <StatusPanel
          v-else-if="scope.cell.column.value === 'status'"
          :thread="scope.cell.item"
          is-assignee-visible
          :on-update-thread="onUpdateThread"
        />
        <SubmittedDatePanel
          v-else-if="scope.cell.column.value === 'created_at'"
          :thread="scope.cell.item"
        />
        <UpdatedDatePanel
          v-else-if="scope.cell.column.value === 'updated_at'"
          :thread="scope.cell.item"
        />
        <template v-else-if="scope.cell.column.value === 'country'">
          {{ displayColumnValue(scope.cell.item, 'country.platform') }}
        </template>
        <template v-else>
          {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
        </template>
      </template>

      <template v-slot:no-data-action>
        <slot name="no-data-action"></slot>
      </template>
    </table-base>
  </div>
</template>

<script>
  import { extractNestedProp } from '@/utils';
  import columns from '../../../config/threads/columnsBC.js';
  import ThreadPanel from '../../panels/threads/Thread';
  import StatusPanel from '../../panels/threads/Status';
  import UpdatedDatePanel from '../../panels/threads/UpdatedDate';
  import CategoryPanel from '../../panels/threads/Category';
  import SubmittedDatePanel from '../../panels/threads/SubmittedDate';
  import StartDatePanel from '../../panels/threads/StartDate';

  // TODO: Translate component

  export default {
    components: {
      ThreadPanel,
      StatusPanel,
      UpdatedDatePanel,
      CategoryPanel,
      SubmittedDatePanel,
      StartDatePanel,
    },
    emits: ['init-pagination'],
    props: {
      threads: {
        type: Array,
        required: true,
      },
      pages: {
        type: Number,
        required: true,
      },
      pagination: {
        type: Object,
        required: true,
      },
      isLoading: {
        type: Boolean,
        required: true,
      },
      onSelectItem: {
        type: Function,
        required: true,
      },
      onUpdatePagination: {
        type: Function,
        required: true,
      },
      onChangePage: {
        type: Function,
        required: true,
      },
      syncToUrl: {
        type: Boolean,
        default: false,
      },
      onUpdateThread: {
        type: Function,
        default: () => {},
      },
      onToggleComments: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        columns
      }
    },
    computed: {
      loggedUserRole() {
        return this.$store.getters['auth/role'];
      },
      totalThreads() {
        return this.pagination.totalItems || 0;
      },
      isBusinessContact() {
        return (
          this.loggedUserRole.slug === 'business_contact' ||
          this.loggedUserRole.slug === 'business_admin'
        );
      },
    },
    methods: {
      displayColumnValue(item, columnValue) {
        return extractNestedProp(item, columnValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use '../../../assets/styles/theme' as *;


</style>
